import { InfoItemProps } from './InfoItemDetails.types';
import InfoItemCol from './InfoItemCol';
import InfoItemRow from './InfoItemRow';

const InfoItemDetails = ({ direction = 'col', ...props }: InfoItemProps) => {
  if (direction === 'row') {
    return <InfoItemRow subscriptionTitle={props.subscriptionTitle} {...props} />;
  }
  return <InfoItemCol {...props} />;
};

export default InfoItemDetails;
